import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

import {
  ActionItems,
  ActionListItem,
  CustomerType,
  Lab,
  LabModes,
  OperationModes,
} from '../../../../modals/lab.model';
import { AprovalField } from '../../../../modals/form-field.model';

import { EventService } from '../../../../services/event.services';
import { LabService } from '../../../../services/lab.service';
import { UtilityService } from '../../../../services/utility.service';

import { CustomValidators, miscellaneousConst, NotificationService, unsubscribeCollection } from '@utility';
import { TranslateService } from '@ngx-translate/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ButtonLoadingService } from '@teams-ui-angular';
import { EventEmitterService } from '@teams-auth';

@Component({
  selector: 'cloudlabs-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit, AfterViewInit, OnDestroy {
  public isSidenav = false;
  public lab: Lab;
  public isHideMenu = true;
  public attendee: any;
  public voucherCode: string;
  public mode: string = LabModes.LAB;
  public labModes: any = LabModes;
  public operationMode: string = OperationModes.INITIATION;
  public hideoverview = true;
  public hidevideo = true;
  public enableHeader = false;
  public enableFooter = false;
  public currentView = 'LAB';
  public isMylearning = false;
  private subscriptions: Subscription[] = [];
  /** for selected not selected screen reader messages */
  overViewSelected = false;
  labViewSelected = true;
  videoViewSelected = false;
  environment;
  public counter = 0;
  public actionList: Array<ActionListItem> = [];
  public actionEvent: any;
  public endDateData: any;
  public updatedLabStatus = false;
  public clientIP: string;
  public showIPpopup = false;
  public ruleNameLength = 80;
  public ruleNameMinLength = 3;
  public showIPOption = false;
  form: FormGroup;
  public showDelete = false;

  constructor(
    private eventSrv: EventService,
    private aroute: ActivatedRoute,
    private labSrv: LabService,
    private titleService: Title,
    private util: UtilityService,
    private route: Router,
    private translateSrv: TranslateService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    public btnLoadingService: ButtonLoadingService,
    private notificationService: NotificationService,
    private eventEmitter: EventEmitterService,
    @Inject('environment')
    environment
  ) {
    this.environment = environment;
    if (localStorage.getItem('context') === miscellaneousConst.cloudlab) {
      this.isMylearning = true;
    }
    if (this.environment.appType !== 'trial') {
      if (!this.isMylearning) {
        this.titleService.setTitle('CloudLabs On Demand lab');
      }
    }
    this.form = this.fb.group({
      records: this.fb.array([]),
    });
  }

  async ngOnInit() {
    this.lab = this.aroute.snapshot.data.lab;
    this.lab.Title = this.lab.DisplayName
      ? this.lab.DisplayName
      : this.lab.Title;
    if (this.isMylearning) {
      this.titleService.setTitle(
        this.lab.Title +
          ' | ' +
          this.translateSrv.instant('HOME.CLOUDLABS_PORTAL')
      );
    }
    // if(this.environment.appType === 'trial'){
    //   this.titleService.setTitle(`${this.lab.PartnerName} Trial`)
    // }
    this.voucherCode = this.aroute.snapshot.params.voucherCode;
    this.attendee = this.aroute.snapshot.data.labattendee;
    if (
      this.lab?.ApprovalTypeId != 1 &&
      this.lab?.ApprovalTypeId != 11 &&
      this.lab?.ApprovalTypeId != 13
    ) {
      if (
        this.attendee?.DeploymentStatus == 'Deleted' ||
        this.attendee?.DeploymentStatus == 'Deleting'
      ) {
        this.isHideMenu = false;
      }
    }
    this.subscriptions[this.subscriptions.length] =
      this.eventSrv.openSideNav.subscribe((res) => {
        this.isSidenav = !this.isSidenav;
      });
    // assign data get from resolvers
    this.eventSrv.setThemeId(this.lab?.ThemeId);
    if (this.lab?.EnableCustomLabDetailsPage === false) {
      this.enableHeader = true;
      this.enableFooter = true;
    }

    // check mode of lab
    if (
      [AprovalField.AnonymousUsers, AprovalField.AutoLaunch].includes(
        this.lab?.ApprovalTypeId
      )
    ) {
      if (this.lab.StatusId === 5) {
        this.mode = LabModes.ANONYMOUS;
        this.operationMode = OperationModes.UNINITIATED;
      } else if (this.lab.StatusId === 6) {
        this.mode = LabModes.INFORMATION;
        this.operationMode = OperationModes.INITIATION;
      } else if (this.voucherCode !== null || this.voucherCode !== undefined) {
        this.mode = LabModes.LAB;
      }
    } else  if (
      this.lab.ApprovalTypeId ===
        AprovalField.ODLRegisterationActivationCodeRequiredAutoLaunch ||
      this.lab.ApprovalTypeId ===
        AprovalField.ODLRegisterationRequiredAutoLaunch
    ) {
      this.mode = LabModes.LAB;
      this.operationMode = OperationModes.GATHERINGINFO;
    } 
    this.subscriptions[this.subscriptions.length] =
      this.labSrv.labDetailsInES.subscribe((labDetails) => {
        if (labDetails) {
          this.lab = labDetails;
          this.lab.Title = this.lab.DisplayName
            ? this.lab.DisplayName
            : this.lab.Title;
        }
      });
    if (this.lab?.ThemeId) {
      this.eventSrv.setThemeId(this.lab.ThemeId);
    }
    if (this.lab?.LinkToVideo !== null && this.lab?.LinkToVideo !== '') {
      this.hidevideo = false;
    }
    this.subscriptions[this.subscriptions.length] =
      this.eventSrv.languageChanged.subscribe((lang) => {
        this.languageChanged(lang);
      });
    this.createActionList();

    this.eventSrv.showIpAddress.subscribe(() => {
      this.loadIPaddress();
    });
  }

  ngAfterViewInit(): void {
    this.util.switchLanguageToDefault(this.lab);
  }

  get records(): FormArray {
    return this.form.get('records') as FormArray;
  }

  loadIPaddress() {
    this.labSrv.getIpAddress().subscribe(
      (response) => {
        if (response) {
          this.clientIP = response.ip;
        }
      },
      (error) => {
        console.error('Error fetching IP address:', error);
      }
    );

    this.labSrv.getAllowedIPList(this.voucherCode).subscribe((res: any) => {
      if (res && res.length > 0) {
        res.forEach(ipData => this.initializeDefaultRecord(ipData));
      } else {
        this.initializeDefaultRecord(null);
      }
      this.showIPpopup = true;
    }, (err) => {
      const code = 'Error - 50088';
      this.eventEmitter.debugAlert(code, err.error);
    });
  }

  initializeDefaultRecord(ipData): void {
    this.records.push(
      this.fb.group({
        ruleName: [ipData && ipData.NSGRuleName ? ipData.NSGRuleName : '',
        [
          Validators.required,
          Validators.minLength(this.ruleNameMinLength),
          Validators.maxLength(this.ruleNameLength),
          Validators.pattern(/^[A-Za-z0-9_-]+$/),
          CustomValidators.uniqueValueValidator(() => this.records.controls, 'ruleName')
        ]],
        ipAddress: [ipData && ipData.IpV4 ? ipData.IpV4 : '',
        [
          Validators.required,
          CustomValidators.ipv4Validator,
          CustomValidators.uniqueValueValidator(() => this.records.controls, 'ipAddress')
        ]],
      })
    );
  }

  addRecord(addClientIp): void {
    if (!this.clientIP) return;

    if (this.records.length >= 5) {
      return;
    }

    const record = this.fb.group({
      ruleName: ['',
        [
          Validators.required,
          Validators.minLength(this.ruleNameMinLength),
          Validators.maxLength(this.ruleNameLength),
          Validators.pattern(/^[A-Za-z0-9_-]+$/),
          CustomValidators.uniqueValueValidator(() => this.records.controls, 'ruleName')
        ]],
      ipAddress: [addClientIp ? this.clientIP : '',
      [
        Validators.required,
        CustomValidators.ipv4Validator,
        CustomValidators.uniqueValueValidator(() => this.records.controls, 'ipAddress')
      ]]
    });

    this.records.push(record);
  }

  deleteRecord(index: number): void {
    this.records.removeAt(index);
  }

  resetRecords(): void {
    this.showIPpopup = false;
    (this.form.get('records') as FormArray).clear();
  }

  saveIPAdress() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      this.btnLoadingService.indexValue = 'ipSave';
      this.btnLoadingService.setLoding(true, this.translateSrv.instant('SAVING'));
      const ipData = this.form.value.records.map(item => {
        return {
          NsgRuleName: item.ruleName,
          IpV4: item.ipAddress
        };
      });
      this.labSrv.addAllowedIPList(this.voucherCode, ipData).subscribe(res => {
        this.btnLoadingService.buttonLodingOff();
        this.notificationService.success(
          this.translateSrv.instant('IP_SAVED_SUCCESSFULLY'),
          null);
        this.resetRecords();
      }, (err) => {
        this.btnLoadingService.buttonLodingOff();
        const code = 'Error - 50089';
        this.eventEmitter.debugAlert(code, err.error);
      });
    }
  }

  actionClickEvent(action) {
    this.actionEvent = action;
    this.eventSrv.actionClickEvent.next(action);
  }

  private createActionList() {
    this.actionList = [
      {
        name: 'RELOAD_INSTANCE',
        icon: 'fa-solid fa-refresh',
        action: ActionItems.RELOAD,
      },
    ];
    this.checkDeallocate();
  }

  checkDeallocate() {
    if (
      ['Deallocated', 'Deployed', 'Deallocating', 'Failed'].includes(this.operationMode)
    ) {
      this.showIPOption = false;
      this.actionList = this.actionList.filter(
        (item) => item.action === ActionItems.RELOAD
      );
      this.showDelete = false;
    }
    if (
      ![
        'Deallocated',
        'Deployed',
        'Deallocating',
        'Initiation',
        'UnInitiated',
        'GatheringInfo',
      ].includes(this.operationMode)
    ) {
      const data = this.actionList.find(
        (item) => item.action === ActionItems.DEALLOCATE
      );
      if (this.lab.AllowUserToDeleteODL && !data) {
        this.actionList.push({
          name: 'DELETE_LAB',
          icon: 'fa-solid fa-trash',
          action: ActionItems.DEALLOCATE,
        });
        this.showDelete = true;
      }
    }
    if (this.operationMode === 'InProgress') {
      if(this.lab.EnableIpRestriction) {
        this.showIPOption = true;
      }
      const data = this.actionList.find(
        (item) => item.action === ActionItems.EXT_CREDIT
      );
      if (this.lab.AllowUserToExtendCredit && !data) {
        this.actionList.push({
          name: 'EXT_CREDIT',
          icon: 'fas fa-dollar-sign',
          action: ActionItems.EXT_CREDIT,
        });
      }
    }
  }

  updateOperationMode(event) {
    this.operationMode = event;
    this.checkDeallocate();
  }

  extendLabAction(event) {
    if (this.actionList[0].action !== ActionItems.EXTEND && event) {
      this.actionList.splice(0, 0, {
        name: 'EXTEND_LAB_DURATION',
        icon: 'fa-solid fa-hourglass-start',
        action: ActionItems.EXTEND,
      });
    }
    if (
      this.actionList[0].action === ActionItems.EXTEND &&
      !event &&
      !this.lab.SkipExtendLimitValidation
    ) {
      this.actionList.splice(0, 1);
    }
  }

  /**
   * collapse sidenav
   */
  closeSidenav() {
    this.isSidenav = !this.isSidenav;
  }

  isCompleteLab(event) {
    this.isHideMenu = event;
  }

  languageChanged(language) {
    this.labSrv.getDetailsInLang(this.aroute.snapshot.params.id, language);
  }
  setView(view: string) {
    this.currentView = view;
    if (view == 'OVERVIEW') {
      this.overViewSelected = true;
      this.labViewSelected = false;
      this.videoViewSelected = false;
    } else if (view == 'LAB') {
      this.overViewSelected = false;
      this.labViewSelected = true;
      this.videoViewSelected = false;
    } else if (view == 'VIDEO') {
      this.overViewSelected = false;
      this.labViewSelected = false;
      this.videoViewSelected = true;
    }
    setTimeout(() => {
      window.dispatchEvent(new Event('resize-tabs'));
    }, 200);
  }

  ngOnDestroy() {
    unsubscribeCollection(this.subscriptions);
  }

  public setCounter(remainingTime: number): void {
    this.counter = remainingTime;
  }

  setEndDate(endDateData) {
    this.endDateData = endDateData;
  }

  public updateLabStatus(labStatus: boolean): void {
    this.updatedLabStatus = labStatus;
  }
}
